import { Icon, colors } from "@hubrise/react-components"
import styled from "styled-components"

export const Outside = styled.div`
  position: relative;
  height: 100%;
`

export const Inside = styled.div<{ scrollbarVisible: boolean }>`
  height: 100%;
  overflow-y: ${(props) => (props.scrollbarVisible ? "auto" : "hidden")};
  padding-right: ${(props) => (props.scrollbarVisible ? "0" : "1.125rem")};
`

const iconSize = 24
const delay = "1s"

const arrow = styled(Icon).attrs({ size: iconSize })`
  position: absolute;
  left: calc(50% - ${iconSize}px / 2);
  display: flex;
  justify-content: center;
  color: ${colors.scrollArrow};
  user-select: none;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear ${delay};

  &.is-visible {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.1s linear ${delay};
  }
`

export const ArrowUp = styled(arrow).attrs({ code: "keyboard_double_arrow_up" })`
  top: 1rem;
`

export const ArrowDown = styled(arrow).attrs({ code: "keyboard_double_arrow_down" })`
  bottom: 1rem;
`
